export default {
  proposalsCount: 588,
  speakersCount: 436,
  proposalsBySpeaker: '1.35',
  formatsCount: [
    {
      id: 'e56e30ab-be22-5055-9138-a86a3249c766',
      label: '📣 Conference',
      value: 360,
    },
    {
      id: 'fc2e9afb-3cba-5428-9214-c146862f2a52',
      label: '⚡️ Quickie',
      value: 153,
    },
    { id: 'unknown', label: 'Not defined', value: 40 },
    {
      id: 'bc4d1840-d260-5fb6-9e83-f1b0da239793',
      label: '💻 Codelab',
      value: 35,
    },
  ],
  categoriesCount: [
    { id: 'cf75cee3-5ee8-58de-ac77-6bb665a3463d', label: '🌍 Web', value: 143 },
    {
      id: '4fee2bdd-0cf4-5429-945c-42a422577ff5',
      label: '☁️ Cloud & DevOps',
      value: 119,
    },
    {
      id: 'ef048dea-2728-54c5-9334-93d0cfe5d981',
      label: '💡 Discovery',
      value: 114,
    },
    {
      id: 'dfa320e4-1f9b-53ee-8c98-3ef48ba81013',
      label: '📱 Mobile & IoT',
      value: 66,
    },
    {
      id: '3e79596d-6302-5601-a027-901bff9e2692',
      label: '📝 Languages',
      value: 46,
    },
    {
      id: 'c97cf20f-aba8-5bcd-9251-72f8c3c536c6',
      label: '🤖 BigData & AI',
      value: 40,
    },
    {
      id: '1e18bcfa-f91a-5ac0-b2f1-ee586837c398',
      label: '🐱‍💻 SECURITY',
      value: 27,
    },
    {
      id: 'b8f42b3e-d1d0-5212-bb39-9dfad1b01661',
      label: '💚 UX / UI',
      value: 21,
    },
    { id: 'unknown', label: 'Not defined', value: 12 },
  ],
  companiesCount: [
    { id: '', label: '', value: 67 },
    { id: 'zenika', label: 'zenika', value: 36 },
    { id: 'sfeir', label: 'sfeir', value: 13 },
    { id: 'ippon-technologies', label: 'ippon-technologies', value: 10 },
    { id: 'stack-labs', label: 'stack-labs', value: 10 },
    { id: 'ovh', label: 'ovh', value: 7 },
    { id: 'freelance', label: 'freelance', value: 6 },
    { id: 'onepoint', label: 'onepoint', value: 6 },
    { id: 'orange', label: 'orange', value: 6 },
    { id: 'talend', label: 'talend', value: 6 },
    { id: 'niji', label: 'niji', value: 6 },
    { id: 'societe-generale', label: 'societe-generale', value: 6 },
    { id: 'maif', label: 'maif', value: 5 },
    { id: 'google', label: 'google', value: 5 },
    { id: 'sopra-steria', label: 'sopra-steria', value: 5 },
    { id: 'wescale', label: 'wescale', value: 5 },
    { id: 'pole-emploi', label: 'pole-emploi', value: 4 },
    { id: 'smart-soft', label: 'smart-soft', value: 4 },
    { id: 'bearstudio', label: 'bearstudio', value: 4 },
    { id: 'microsoft', label: 'microsoft', value: 4 },
    { id: 'monkeypatch', label: 'monkeypatch', value: 4 },
    { id: 'webnet', label: 'webnet', value: 3 },
    { id: 'xebia-france', label: 'xebia-france', value: 3 },
    { id: 'xebia', label: 'xebia', value: 3 },
    { id: 'capgemini', label: 'capgemini', value: 3 },
    { id: 'code-lutin', label: 'code-lutin', value: 3 },
    { id: 'asi', label: 'asi', value: 3 },
    { id: 'lectra', label: 'lectra', value: 3 },
    { id: 'sogeti', label: 'sogeti', value: 3 },
    { id: 'takima', label: 'takima', value: 3 },
    { id: 'symbol-it', label: 'symbol-it', value: 2 },
    { id: 'valeuriad', label: 'valeuriad', value: 2 },
    { id: 'akeneo', label: 'akeneo', value: 2 },
    { id: 'knp-labs', label: 'knp-labs', value: 2 },
    { id: 'norsys', label: 'norsys', value: 2 },
    { id: 'apside', label: 'apside', value: 2 },
    { id: 'bonitasoft', label: 'bonitasoft', value: 2 },
    { id: 'thales-services', label: 'thales-services', value: 2 },
    { id: 'bouygues-telecom', label: 'bouygues-telecom', value: 2 },
    { id: 'sii', label: 'sii', value: 2 },
    { id: 'fabernovel', label: 'fabernovel', value: 2 },
    { id: 'matos-btp', label: 'matos-btp', value: 2 },
    { id: 'clever-cloud', label: 'clever-cloud', value: 2 },
    { id: 'umanis', label: 'umanis', value: 2 },
    { id: 'rca', label: 'rca', value: 2 },
    { id: 'radio-france', label: 'radio-france', value: 2 },
    { id: 'saagie', label: 'saagie', value: 2 },
    { id: 'docker', label: 'docker', value: 2 },
    { id: 'red-hat', label: 'red-hat', value: 2 },
    { id: 'theodo', label: 'theodo', value: 2 },
    { id: 'soprasteria', label: 'soprasteria', value: 2 },
    { id: 'source-d', label: 'source-d', value: 2 },
    { id: 'sonarsource', label: 'sonarsource', value: 2 },
    { id: 'les-tilleuls', label: 'les-tilleuls', value: 2 },
    { id: 'cedreo', label: 'cedreo', value: 2 },
    { id: 'toki', label: 'toki', value: 2 },
    { id: 'iadvize', label: 'iadvize', value: 2 },
    {
      id: 'informatique-banque-populaire',
      label: 'informatique-banque-populaire',
      value: 2,
    },
    { id: 'access-42', label: 'access-42', value: 2 },
    { id: 'kaviar-app', label: 'kaviar-app', value: 1 },
    { id: 'orange-labs', label: 'orange-labs', value: 1 },
    { id: 'softeam', label: 'softeam', value: 1 },
    { id: 'mozilla', label: 'mozilla', value: 1 },
    {
      id: 'nc-dept-of-health-human-services',
      label: 'nc-dept-of-health-human-services',
      value: 1,
    },
    { id: 'extia', label: 'extia', value: 1 },
    { id: 'hedy-tech', label: 'hedy-tech', value: 1 },
    { id: 'alexis-jacomy', label: 'alexis-jacomy', value: 1 },
    { id: 'mnt', label: 'mnt', value: 1 },
    { id: 'ippon-technology', label: 'ippon-technology', value: 1 },
    { id: 'egencia-europe', label: 'egencia-europe', value: 1 },
    { id: 'egencia', label: 'egencia', value: 1 },
    { id: 'axa-france', label: 'axa-france', value: 1 },
    { id: 'u-iris', label: 'u-iris', value: 1 },
    { id: 'kezaweb', label: 'kezaweb', value: 1 },
    { id: 'travelaer', label: 'travelaer', value: 1 },
    { id: 'squad', label: 'squad', value: 1 },
    { id: 'semi-technologies', label: 'semi-technologies', value: 1 },
    { id: 'thetribe', label: 'thetribe', value: 1 },
    { id: 'asi-rennes', label: 'asi-rennes', value: 1 },
    { id: 'veolia', label: 'veolia', value: 1 },
    { id: 'wso-2', label: 'wso-2', value: 1 },
    { id: 'symphony', label: 'symphony', value: 1 },
    { id: 'uni-rakun', label: 'uni-rakun', value: 1 },
    { id: 'suravenir-assurances', label: 'suravenir-assurances', value: 1 },
    { id: 'sgcib', label: 'sgcib', value: 1 },
    { id: 'kaliop', label: 'kaliop', value: 1 },
    { id: 'ippon-nantes', label: 'ippon-nantes', value: 1 },
    { id: 'telefonica', label: 'telefonica', value: 1 },
    { id: 'sii-atlantique', label: 'sii-atlantique', value: 1 },
    {
      id: 'startup-palace-freelance',
      label: 'startup-palace-freelance',
      value: 1,
    },
    { id: 'cinemur', label: 'cinemur', value: 1 },
    {
      id: 'grenika-zenika-grenoble',
      label: 'grenika-zenika-grenoble',
      value: 1,
    },
    { id: 'wishtack', label: 'wishtack', value: 1 },
    { id: 'klm-linkit', label: 'klm-linkit', value: 1 },
    { id: 'accenture-technology', label: 'accenture-technology', value: 1 },
    { id: 'palo-it', label: 'palo-it', value: 1 },
    { id: 'capgemini-invent', label: 'capgemini-invent', value: 1 },
    { id: 'jobsity', label: 'jobsity', value: 1 },
    { id: 'sitepen', label: 'sitepen', value: 1 },
    { id: 'spacelephant', label: 'spacelephant', value: 1 },
    { id: 'space-elephant', label: 'space-elephant', value: 1 },
    { id: 'viseo', label: 'viseo', value: 1 },
    { id: 'sfeir-gdg-nantes', label: 'sfeir-gdg-nantes', value: 1 },
    { id: 'asmodee-digitial', label: 'asmodee-digitial', value: 1 },
    { id: 'prestapp', label: 'prestapp', value: 1 },
    { id: 'pivotal-labs', label: 'pivotal-labs', value: 1 },
    { id: 'decathlon', label: 'decathlon', value: 1 },
    { id: 'elium', label: 'elium', value: 1 },
    { id: 'speachme', label: 'speachme', value: 1 },
    { id: 'kiplin', label: 'kiplin', value: 1 },
    { id: 'stampyt', label: 'stampyt', value: 1 },
    { id: 'valwin', label: 'valwin', value: 1 },
    { id: 'dvt', label: 'dvt', value: 1 },
    { id: 'acensi', label: 'acensi', value: 1 },
    { id: 'knplabs', label: 'knplabs', value: 1 },
    { id: 'thales', label: 'thales', value: 1 },
    { id: 'datadog', label: 'datadog', value: 1 },
    {
      id: 'casden-banque-populaire',
      label: 'casden-banque-populaire',
      value: 1,
    },
    { id: 'akamai-technologies', label: 'akamai-technologies', value: 1 },
    { id: 'open', label: 'open', value: 1 },
    { id: 'magellium', label: 'magellium', value: 1 },
    { id: 'wework', label: 'wework', value: 1 },
    { id: 'schoolmouv', label: 'schoolmouv', value: 1 },
    { id: 'iadvize-nantes', label: 'iadvize-nantes', value: 1 },
    { id: 'mphasis-ltd', label: 'mphasis-ltd', value: 1 },
    { id: 'accenture', label: 'accenture', value: 1 },
    { id: 'creative-ingenierie', label: 'creative-ingenierie', value: 1 },
    { id: 'oui-sncf', label: 'oui-sncf', value: 1 },
    { id: 'one-hundred-acorns', label: 'one-hundred-acorns', value: 1 },
    { id: 'wit-software', label: 'wit-software', value: 1 },
    { id: 'kbdev', label: 'kbdev', value: 1 },
    { id: 'harpp', label: 'harpp', value: 1 },
    { id: 'digitalocean', label: 'digitalocean', value: 1 },
    { id: 'miles-as', label: 'miles-as', value: 1 },
    {
      id: 'schibsted-spain-infojobs',
      label: 'schibsted-spain-infojobs',
      value: 1,
    },
    { id: 'gfi-informatique', label: 'gfi-informatique', value: 1 },
    { id: 'fabulous-lab', label: 'fabulous-lab', value: 1 },
    { id: 'docker-inc', label: 'docker-inc', value: 1 },
    { id: 'lucca', label: 'lucca', value: 1 },
    { id: 'red-hat-mozilla', label: 'red-hat-mozilla', value: 1 },
    { id: 'fenikso', label: 'fenikso', value: 1 },
    { id: 'leboncoin', label: 'leboncoin', value: 1 },
    {
      id: 'velvet-lemons-consulting',
      label: 'velvet-lemons-consulting',
      value: 1,
    },
    { id: 'ngking', label: 'ngking', value: 1 },
    { id: 'continental', label: 'continental', value: 1 },
    { id: 'ekino', label: 'ekino', value: 1 },
    { id: 'clearleft', label: 'clearleft', value: 1 },
    { id: 'santeclair', label: 'santeclair', value: 1 },
    { id: 'air-france-klm', label: 'air-france-klm', value: 1 },
    { id: 'pivotal', label: 'pivotal', value: 1 },
    { id: 'hello-design', label: 'hello-design', value: 1 },
    { id: 'sii-ouest', label: 'sii-ouest', value: 1 },
    { id: 'greenspector', label: 'greenspector', value: 1 },
    { id: 'equinoa', label: 'equinoa', value: 1 },
    { id: 'jems-datafactory', label: 'jems-datafactory', value: 1 },
    {
      id: 'sii-rennes-epitech-nantes',
      label: 'sii-rennes-epitech-nantes',
      value: 1,
    },
    { id: 'epam', label: 'epam', value: 1 },
    { id: 'zenika-nantes', label: 'zenika-nantes', value: 1 },
    { id: 'gladys-assistant', label: 'gladys-assistant', value: 1 },
    { id: 'computas', label: 'computas', value: 1 },
    { id: 'macif', label: 'macif', value: 1 },
    { id: 'serli', label: 'serli', value: 1 },
    { id: 'alto-labs', label: 'alto-labs', value: 1 },
    { id: 'avalon-solutions', label: 'avalon-solutions', value: 1 },
    { id: 'nilhcem', label: 'nilhcem', value: 1 },
    { id: 'rtone', label: 'rtone', value: 1 },
    {
      id: 'orange-application-for-business',
      label: 'orange-application-for-business',
      value: 1,
    },
    { id: 'i-have-a-green', label: 'i-have-a-green', value: 1 },
    { id: 'dy-dx', label: 'dy-dx', value: 1 },
    { id: 'code-troopers', label: 'code-troopers', value: 1 },
    { id: 'carbon-it', label: 'carbon-it', value: 1 },
    {
      id: 'societe-generale-owasp-fundation',
      label: 'societe-generale-owasp-fundation',
      value: 1,
    },
    {
      id: 'ouest-france-image-charts',
      label: 'ouest-france-image-charts',
      value: 1,
    },
    { id: 'nearform', label: 'nearform', value: 1 },
    { id: 'instant-system', label: 'instant-system', value: 1 },
    { id: 'crossknowledge', label: 'crossknowledge', value: 1 },
    { id: 'cloudbees', label: 'cloudbees', value: 1 },
    { id: 'toptal', label: 'toptal', value: 1 },
    { id: 'la-combe-du-lion-vert', label: 'la-combe-du-lion-vert', value: 1 },
    { id: 'auth-0', label: 'auth-0', value: 1 },
    { id: 'impact', label: 'impact', value: 1 },
    { id: 'sap', label: 'sap', value: 1 },
    { id: 'worldline', label: 'worldline', value: 1 },
    { id: 'asmodee-digital', label: 'asmodee-digital', value: 1 },
    { id: 'elastic', label: 'elastic', value: 1 },
    { id: 'dernier-cri', label: 'dernier-cri', value: 1 },
    { id: 'harmonie-mutuelle', label: 'harmonie-mutuelle', value: 1 },
    { id: 'les-tilleuls-coop', label: 'les-tilleuls-coop', value: 1 },
    { id: 'neos', label: 'neos', value: 1 },
    { id: 'sf≡ir', label: 'sf≡ir', value: 1 },
    { id: 'benext', label: 'benext', value: 1 },
  ],
  countriesCount: [
    { id: 'FR', label: 'FR', value: 306 },
    { id: 'unknown', label: 'unknown', value: 98 },
    { id: 'US', label: 'US', value: 4 },
    { id: 'ES', label: 'ES', value: 3 },
    { id: 'SE', label: 'SE', value: 2 },
    { id: 'DE', label: 'DE', value: 2 },
    { id: 'GB', label: 'GB', value: 2 },
    { id: 'CH', label: 'CH', value: 2 },
    { id: 'CA', label: 'CA', value: 2 },
    { id: 'NO', label: 'NO', value: 2 },
    { id: 'NL', label: 'NL', value: 2 },
    { id: 'AT', label: 'AT', value: 1 },
    { id: 'LU', label: 'LU', value: 1 },
    { id: 'PL', label: 'PL', value: 1 },
    { id: 'ZA', label: 'ZA', value: 1 },
    { id: 'IN', label: 'IN', value: 1 },
    { id: 'PT', label: 'PT', value: 1 },
    { id: 'HU', label: 'HU', value: 1 },
    { id: 'BE', label: 'BE', value: 1 },
    { id: 'LK', label: 'LK', value: 1 },
    { id: 'RS', label: 'RS', value: 1 },
    { id: 'CO', label: 'CO', value: 1 },
  ],
  proposalsByDate: [
    { day: '2019-06-30', value: 87 },
    { day: '2019-06-29', value: 32 },
    { day: '2019-06-28', value: 75 },
    { day: '2019-06-27', value: 11 },
    { day: '2019-06-26', value: 21 },
    { day: '2019-06-25', value: 27 },
    { day: '2019-06-24', value: 6 },
    { day: '2019-06-23', value: 4 },
    { day: '2019-06-22', value: 3 },
    { day: '2019-06-21', value: 6 },
    { day: '2019-06-20', value: 1 },
    { day: '2019-06-19', value: 11 },
    { day: '2019-06-18', value: 3 },
    { day: '2019-06-17', value: 20 },
    { day: '2019-06-16', value: 2 },
    { day: '2019-06-15', value: 2 },
    { day: '2019-06-14', value: 9 },
    { day: '2019-06-13', value: 9 },
    { day: '2019-06-12', value: 4 },
    { day: '2019-06-11', value: 4 },
    { day: '2019-06-10', value: 4 },
    { day: '2019-06-09', value: 2 },
    { day: '2019-06-08', value: 4 },
    { day: '2019-06-07', value: 8 },
    { day: '2019-06-06', value: 1 },
    { day: '2019-06-04', value: 18 },
    { day: '2019-06-03', value: 12 },
    { day: '2019-06-02', value: 2 },
    { day: '2019-05-31', value: 1 },
    { day: '2019-05-29', value: 6 },
    { day: '2019-05-28', value: 5 },
    { day: '2019-05-27', value: 11 },
    { day: '2019-05-26', value: 2 },
    { day: '2019-05-25', value: 6 },
    { day: '2019-05-24', value: 14 },
    { day: '2019-05-23', value: 8 },
    { day: '2019-05-22', value: 8 },
    { day: '2019-05-21', value: 5 },
    { day: '2019-05-20', value: 3 },
    { day: '2019-05-19', value: 4 },
    { day: '2019-05-18', value: 1 },
    { day: '2019-05-17', value: 2 },
    { day: '2019-05-15', value: 2 },
    { day: '2019-05-14', value: 6 },
    { day: '2019-05-13', value: 4 },
    { day: '2019-05-11', value: 4 },
    { day: '2019-05-10', value: 9 },
    { day: '2019-05-09', value: 4 },
    { day: '2019-05-08', value: 9 },
    { day: '2019-05-07', value: 4 },
    { day: '2019-05-06', value: 10 },
    { day: '2019-05-05', value: 10 },
    { day: '2019-05-03', value: 24 },
    { day: '2019-05-02', value: 22 },
    { day: '2019-05-01', value: 16 },
  ],
};
